module.exports = __webpack_public_path__ + "static/media/4.83fc5aea.jpg";